import { gql, TypedDocumentNode } from '@apollo/client'
import type { CountryFragment } from './__generated__/CountryFragment'

export const countryFragment: TypedDocumentNode<CountryFragment> = gql`
  fragment CountryFragment on Country {
    eeaMember
    id
    isoCode
    nameEn
    nameFr
    nameNl
    nationality(locale: $locale)
  }
`
